/* عالم سمسم – سلة أسهل + شريط الشحن المجاني (من 6,000 ج.م)
   - شريط «أضف كذا وتحصل على شحن مجاني» في السلة الجانبية وصفحة السلة
   - ملاحظة الطلب وكود الخصم بيتفتحوا بضغطة بدل ما ياخدوا مساحة
   - زرار «إتمام الطلب» ثابت تحت الشاشة في صفحة السلة على الموبايل */
(function () {
  if (window.SMSMCP) return; window.SMSMCP = 1;
  var FREE = 600000; /* 6,000 ج.م بالقرش — نفس حد خصم الشحن المجاني في شوبيفاي */
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cart = null, busy = 0, tmr;

  function fmt(c) { var v = Math.ceil(c / 100).toLocaleString('en-US'); return EN ? 'EGP ' + v : v + ' ج.م'; }
  function onCart() { return /\/cart\/?$/.test(location.pathname); }
  function mob() { return window.matchMedia('(max-width: 989px)').matches; }

  function css() {
    if (document.getElementById('smsm-cp-css')) return;
    var s = document.createElement('style'); s.id = 'smsm-cp-css';
    s.textContent = '' +
      '.smsm-ship{position:relative;margin:0 0 16px;padding:12px 14px 13px;border-radius:16px;background:linear-gradient(135deg,#FBF6E6 0%,#F4ECFF 100%);border:1px solid #E9D9A6;font-family:inherit;color:#2B1748;box-shadow:0 10px 24px -18px rgba(75,30,120,.6)}' +
      '.smsm-ship[hidden]{display:none!important}' +
      '.smsm-ship__row{display:flex;align-items:center;gap:10px;margin:0 0 9px}' +
      '.smsm-ship__ic{flex:0 0 34px;width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#4B1E78;color:#fff;font-size:17px;line-height:1;box-shadow:0 6px 14px -8px rgba(75,30,120,.9)}' +
      '.smsm-ship__t{margin:0;font-size:13.5px;line-height:1.55;font-weight:700;color:#2B1748}' +
      '.smsm-ship__t b{color:#4B1E78;font-weight:900}' +
      '.smsm-ship__t .smsm-ship__amt{display:inline-block;background:#4B1E78;color:#F3E3A6;padding:0 8px;border-radius:999px;font-weight:900;white-space:nowrap}' +
      '.smsm-ship__track{position:relative;height:9px;border-radius:999px;background:rgba(75,30,120,.12);overflow:hidden}' +
      '.smsm-ship__fill{position:absolute;inset-block:0;inset-inline-start:0;width:0;border-radius:999px;background:linear-gradient(90deg,#BF9A26,#E2C35A);transition:width .6s cubic-bezier(.2,.8,.2,1)}' +
      '.smsm-ship__fill::after{content:"";position:absolute;inset:0;background:linear-gradient(90deg,transparent,rgba(255,255,255,.55),transparent);animation:smsmShipShine 2.4s ease-in-out infinite}' +
      '@keyframes smsmShipShine{from{transform:translateX(-100%)}to{transform:translateX(100%)}}' +
      '.smsm-ship__lbl{display:flex;justify-content:space-between;margin-top:5px;font-size:11px;font-weight:700;color:#7A6A90}' +
      '.smsm-ship.is-free{background:linear-gradient(135deg,#ECFBF1 0%,#F4ECFF 100%);border-color:#9FDDB4}' +
      '.smsm-ship.is-free .smsm-ship__ic{background:#1F9D55}' +
      '.smsm-ship.is-free .smsm-ship__fill{background:linear-gradient(90deg,#1F9D55,#4CC27E)}' +
      '.smsm-ship.is-pop{animation:smsmShipPop .5s ease}' +
      '@keyframes smsmShipPop{0%{transform:scale(1)}40%{transform:scale(1.03)}100%{transform:scale(1)}}' +
      /* ملاحظة الطلب وكود الخصم: بيتفتحوا بضغطة */
      '.smsm-fold>h6{cursor:pointer;display:flex;align-items:center;gap:8px;margin:0!important;padding:4px 0;font-size:14px;color:#4B1E78;user-select:none}' +
      '.smsm-fold>h6::before{content:"+";flex:0 0 22px;width:22px;height:22px;border-radius:50%;border:1.5px solid #4B1E78;display:flex;align-items:center;justify-content:center;font-weight:900;line-height:1;font-size:15px}' +
      '.smsm-fold.is-open>h6::before{content:"−"}' +
      '.smsm-fold:not(.is-open)>:not(h6){display:none!important}' +
      '.smsm-fold.is-open>h6{margin-bottom:12px!important}' +
      'cart-note.smsm-fold{padding-bottom:14px!important;margin-bottom:14px!important}' +
      'cart-discount.smsm-fold{margin:0 0 14px!important;padding-bottom:0!important}' +
      /* شريط الدفع الثابت على الموبايل */
      '.smsm-stick{position:fixed;inset-inline:0;bottom:var(--smsm-stick-b,0px);z-index:60;display:flex;align-items:center;gap:12px;padding:10px 14px calc(10px + env(safe-area-inset-bottom,0px));background:#fff;border-top:1px solid #EDE3F7;box-shadow:0 -10px 26px -14px rgba(43,23,72,.45);transform:translateY(120%);transition:transform .3s ease;font-family:inherit}' +
      '.smsm-stick.is-on{transform:none}' +
      '.smsm-stick__sum{flex:1;min-width:0;line-height:1.3}' +
      '.smsm-stick__sum small{display:block;font-size:11.5px;color:#7A6A90;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.smsm-stick__sum b{font-size:17px;color:#2B1748;font-weight:900}' +
      '.smsm-stick__btn{flex:0 0 auto;border:0;border-radius:14px;min-height:48px;padding:0 20px;font-family:inherit;font-weight:900;font-size:15px;color:#fff;background:#4B1E78;box-shadow:0 10px 20px -10px rgba(75,30,120,.9);cursor:pointer}' +
      'html.smsm-stick-on .smsm-floating-whatsapp{opacity:0!important;pointer-events:none!important}' +
      '@media (min-width:990px){.smsm-stick{display:none!important}}';
    document.head.appendChild(s);
  }

  /* ===== شريط الشحن المجاني ===== */
  function makeBar() {
    var el = document.createElement('div'); el.className = 'smsm-ship'; el.dir = EN ? 'ltr' : 'rtl'; el.hidden = true;
    el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<div class="smsm-ship__row"><span class="smsm-ship__ic" aria-hidden="true">🚚</span><p class="smsm-ship__t"></p></div>' +
      '<div class="smsm-ship__track"><i class="smsm-ship__fill"></i></div>' +
      '<div class="smsm-ship__lbl"><span>0</span><span>' + (EN ? 'Free shipping ' : 'شحن مجاني ') + fmt(FREE) + '</span></div>';
    return el;
  }
  function paint(el) {
    if (!cart || !cart.item_count) { el.hidden = true; return; }
    var sub = cart.items_subtotal_price, left = FREE - sub, p = Math.max(4, Math.min(100, sub / FREE * 100));
    var free = left <= 0, was = el.classList.contains('is-free');
    el.hidden = false;
    el.classList.toggle('is-free', free);
    if (free && !was && el.dataset.ok) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
    el.dataset.ok = 1;
    var key = free ? 'f' : String(left);
    if (el.dataset.k === key) return; /* مفيش تغيير — منكتبش تاني (عشان المراقبة ما تلفّش) */
    el.dataset.k = key;
    el.querySelector('.smsm-ship__ic').textContent = free ? '🎉' : '🚚';
    el.querySelector('.smsm-ship__t').innerHTML = free
      ? (EN ? 'Congrats! Your order ships <b>for FREE</b>' : 'مبروك! طلبك عليه <b>شحن مجاني</b>')
      : (EN ? 'Add <span class="smsm-ship__amt">' + fmt(left) + '</span> more and get <b>FREE shipping</b>'
            : 'أضف <span class="smsm-ship__amt">' + fmt(left) + '</span> كمان واحصل على <b>شحن مجاني</b>');
    el.querySelector('.smsm-ship__fill').style.width = p + '%';
  }
  function place() {
    var spots = [];
    var mb = document.querySelector('#minicart-form .minicart-body'); if (mb) spots.push(mb);
    if (onCart()) { var cl = document.querySelector('.cart-left'); if (cl) spots.push(cl); }
    spots.forEach(function (box) {
      var b = box.querySelector(':scope > .smsm-ship');
      if (!b) { css(); b = makeBar(); box.insertBefore(b, box.firstChild); }
      paint(b);
    });
  }

  /* ===== صفحة السلة: ملاحظة + خصم بيتفتحوا بضغطة ===== */
  function fold(el, label, keepOpen) {
    if (!el || el.classList.contains('smsm-fold')) return;
    var h = el.querySelector(':scope > h6'); if (!h) return;
    css(); el.classList.add('smsm-fold'); h.textContent = label;
    h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0');
    if (keepOpen) el.classList.add('is-open');
    var t = function () { el.classList.toggle('is-open'); if (el.classList.contains('is-open')) { var i = el.querySelector('textarea,input:not([type=hidden])'); if (i) setTimeout(function () { i.focus(); }, 30); } };
    h.addEventListener('click', t);
    h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t(); } });
  }
  function tidy() {
    if (!onCart()) return;
    var n = document.querySelector('cart-note.cart__note'); var ta = n && n.querySelector('textarea');
    fold(n, EN ? 'Add an order note (optional)' : 'إضافة ملاحظة للطلب (اختياري)', ta && ta.value.trim());
    var d = document.querySelector('cart-discount.cart__discount');
    var applied = document.querySelector('.cart-info .js-contents_discounts');
    fold(d, EN ? 'Have a discount code?' : 'عندك كود خصم؟', applied && applied.textContent.trim());
  }

  /* ===== صفحة السلة: شيل كلمة «الضرائب» من «يتم احتساب الضرائب والشحن والخصومات...» ===== */
  function notax() {
    document.querySelectorAll('.cart-info .js-contents_discounts p').forEach(function (p) {
      var w = document.createTreeWalker(p, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) { if (/الضرائب\s*و/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/الضرائب\s*و/, ''); }
    });
  }

  /* ===== تغليف الهدية: «تغليف كهدية (350 جنيه)» بدل «يرجى تغليف المنتج بعناية 350 EGP.» ===== */
  function giftLbl() {
    var els = [].slice.call(document.querySelectorAll('#gift label, #gift label *, .cart-footeraddon *')).filter(function (e) {
      if (e.dataset.smsmG) return false;
      var t = e.textContent; if (!/يرجى تغليف المنتج بعناية|Please wrap the product carefully/i.test(t) || t.length > 120) return false;
      return ![].some.call(e.children, function (k) { return /يرجى تغليف|Please wrap/i.test(k.textContent); });
    });
    els.forEach(function (e) {
      var m = e.textContent.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/), v = m ? Math.round(+m[1]) : 350;
      e.textContent = EN ? 'Gift wrap (EGP ' + v.toLocaleString('en-US') + ')' : 'تغليف كهدية (' + v.toLocaleString('en-US') + ' جنيه)';
      e.dataset.smsmG = 1;
    });
  }

  /* ===== اسم الزرار أوضح: «إتمام الطلب» ===== */
  function relabel() {
    var L = EN ? 'Complete order' : 'إتمام الطلب';
    document.querySelectorAll('.cart__checkout-button, #minicart-form .btn-checkout').forEach(function (b) {
      if (b.dataset.smsmL) return;
      var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) { if (/الدفع|check\s*out/i.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(/الدفع|check\s*out/i, L); b.dataset.smsmL = 1; } }
    });
  }

  /* ===== صفحة السلة على الموبايل: زرار إتمام الطلب ثابت تحت ===== */
  var stick, io;
  function navH() {
    var h = 0;
    document.querySelectorAll('[id*="mobile_navigation_bar"] *').forEach(function (e) {
      if (h) return; var cs = getComputedStyle(e);
      if (cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden') { var r = e.getBoundingClientRect(); if (r.height > 20 && r.bottom >= innerHeight - 2) h = r.height; }
    });
    return h;
  }
  function sticky() {
    if (!onCart()) return;
    var real = document.getElementById('checkout') || document.querySelector('.cart__checkout-button');
    if (!real || !cart || !cart.item_count) { if (stick) stick.classList.remove('is-on'); document.documentElement.classList.remove('smsm-stick-on'); return; }
    css();
    if (!stick) {
      stick = document.createElement('div'); stick.className = 'smsm-stick'; stick.dir = EN ? 'ltr' : 'rtl';
      stick.innerHTML = '<div class="smsm-stick__sum"><small></small><b></b></div><button type="button" class="smsm-stick__btn"></button>';
      stick.querySelector('button').textContent = (EN ? 'Complete order' : 'إتمام الطلب') + (EN ? ' →' : ' ←');
      stick.querySelector('button').addEventListener('click', function () { var r = document.getElementById('checkout') || document.querySelector('.cart__checkout-button'); if (r) r.click(); });
      document.body.appendChild(stick);
    }
    var left = FREE - cart.items_subtotal_price;
    stick.querySelector('small').textContent = left > 0 ? (EN ? fmt(left) + ' away from free shipping' : 'باقي ' + fmt(left) + ' على الشحن المجاني') : (EN ? '🎉 Free shipping' : '🎉 شحن مجاني');
    stick.querySelector('b').textContent = fmt(cart.total_price);
    stick.style.setProperty('--smsm-stick-b', navH() + 'px');
    if (io) io.disconnect();
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        var vis = es[0].isIntersecting, on = !vis && mob();
        stick.classList.toggle('is-on', on); document.documentElement.classList.toggle('smsm-stick-on', on);
      });
      io.observe(real);
    }
  }

  /* ===== تحديث ===== */
  function render() { notax(); giftLbl(); place(); tidy(); relabel(); sticky(); }
  function refresh() {
    clearTimeout(tmr);
    tmr = setTimeout(function () {
      fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); })
        .then(function (c) { cart = c; render(); }).catch(function () {});
    }, 150);
  }
  var RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var _f = window.fetch;
  if (_f) window.fetch = function (i) {
    var u = typeof i === 'string' ? i : (i && i.url) || '', p = _f.apply(this, arguments);
    if (RX.test(u)) p.then(function () { refresh(); setTimeout(refresh, 900); }).catch(function () {});
    return p;
  };
  var _o = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (RX.test(String(u))) this.addEventListener('loadend', function () { refresh(); });
    return _o.apply(this, arguments);
  };
  function watch() {
    notax(); giftLbl(); relabel();
    refresh();
    if (!('MutationObserver' in window)) return;
    var mt;
    var mo = new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(function () { if (cart) render(); }, 60); });
    var a = document.getElementById('minicart-form'); if (a) mo.observe(a, { childList: true, subtree: true });
    var b = document.querySelector('.main-cart'); if (b) mo.observe(b, { childList: true, subtree: true });
    window.addEventListener('resize', function () { if (cart) sticky(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* عالم سمسم – شكل صفحة السلة: كروت للمنتجات + كارت الشحن المجاني + كارت «أرسل الطلب كهدية» + ملخص الطلب بـ«وفّرت كذا» */
(function () {
  if (window.SMSMCL) return; window.SMSMCL = 1;
  if (!/\/cart\/?$/.test(location.pathname)) return;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FREE = 600000, cart = null, cmp = {}, busy = 0;
  function fmt(c) { var v = (Math.round(c) / 100).toLocaleString('en-US', { maximumFractionDigits: 2 }); return EN ? 'EGP ' + v : v + ' ج.م'; }
  function T(a, e) { return EN ? e : a; }

  var css = '' +
    /* كروت المنتجات */
    '.main-cart table.cart-items,.main-cart table.cart-items tbody{display:block;width:100%}' +
    '.main-cart table.cart-items thead{display:none!important}' +
    '.main-cart table.cart-items tbody tr.cart-item,.main-cart table.cart-items tbody tr[id^="CartItem"]{position:relative;display:grid!important;grid-template-columns:96px 1fr auto;grid-template-areas:"img name tot" "img price qty";align-items:center;gap:6px 16px;padding:16px 16px 16px 52px;margin:0 0 14px;border:1px solid #E4D9F1;border-radius:16px;background:#fff;box-shadow:0 8px 22px -20px rgba(75,30,120,.55)}' +
    '[dir="rtl"] .main-cart table.cart-items tbody tr.cart-item,[dir="rtl"] .main-cart table.cart-items tbody tr[id^="CartItem"]{padding:16px 16px 16px 52px}' +
    '.main-cart tr.cart-item>td,.main-cart tr[id^="CartItem"]>td{display:block;border:0!important;padding:0!important;width:auto!important}' +
    '.main-cart tr.cart-item>td.cart-item__media,.main-cart tr[id^="CartItem"]>td.cart-item__media{grid-area:img}' +
    '.main-cart td.cart-item__media .cart-item__link{display:block;width:96px;height:96px;border:1px solid #EFE8F7;border-radius:12px;background:#FAF8FD;overflow:hidden}' +
    '.main-cart td.cart-item__media .cart-item__link img{width:100%!important;height:100%!important;object-fit:contain}' +
    '.main-cart tr>td.cart-item__details{grid-area:name;align-self:end}' +
    '.main-cart tr>td.cart-item__details .cart_info{margin:0!important}' +
    '.main-cart tr>td.cart-item__details .product-item__name{font-size:15px!important;font-weight:800;color:#2B1748;line-height:1.5}' +
    '.main-cart tr>td.cart__page-price{grid-area:price;align-self:start}' +
    '.main-cart tr>td.cart__page-price .product-option{font-size:15px;font-weight:800;color:#C0392B}' +
    '.main-cart .smsm-cmp{display:inline-block;margin-inline-start:8px;font-size:13px;font-weight:600;color:#9A90AA;text-decoration:line-through}' +
    '.main-cart tr>td.cart-item__quantity{grid-area:qty;justify-self:end}' +
    '.main-cart tr>td:last-child:not(.cart-item__media):not(.cart-item__details):not(.cart__page-price):not(.cart-item__quantity){grid-area:tot;justify-self:end;align-self:end}' +
    '.main-cart tr>td:last-child .price{font-size:15px;font-weight:900;color:#2B1748}' +
    '.main-cart tr>td:last-child .price::before{content:"' + T('المجموع: ', 'Total: ') + '";font-weight:700;color:#7A6A90;font-size:13px}' +
    '.main-cart .cart-items-action{position:absolute;top:14px;inset-inline-end:14px;z-index:2}' +
    '.main-cart .cart-items-action .cart-remove{width:28px;height:28px;border-radius:50%;background:#F15B5B;color:#fff!important;display:inline-flex;align-items:center;justify-content:center;box-shadow:0 6px 12px -6px rgba(241,91,91,.8)}' +
    '.main-cart .cart-items-action .cart-remove svg{width:13px;height:13px;color:#fff;fill:currentColor}' +
    '.main-cart .cart-items-action .cart-remove *{color:#fff!important}' +
    '.main-cart .cart-items-action a:not(.cart-remove){display:none}' +
    '@media (max-width:749px){.main-cart table.cart-items tbody tr.cart-item,.main-cart table.cart-items tbody tr[id^="CartItem"]{grid-template-columns:76px 1fr;grid-template-areas:"img name" "img price" "qty tot";padding:14px 14px 14px 46px!important}' +
    '.main-cart td.cart-item__media .cart-item__link{width:76px;height:76px}.main-cart tr>td.cart-item__quantity{justify-self:start}}' +
    /* كروت الجنب */
    '.smsm-side{display:flex;align-items:center;gap:14px;margin:0 0 14px;padding:18px;border-radius:16px;background:#fff;border:1px solid #ECE4F5;box-shadow:0 8px 22px -20px rgba(75,30,120,.55)}' +
    '.smsm-side__ic{flex:0 0 56px;width:56px;height:56px;border-radius:50%;background:#2B1748;color:#fff;display:flex;align-items:center;justify-content:center;font-size:24px}' +
    '.smsm-side__t{margin:0;font-size:16px;font-weight:900;color:#2B1748}' +
    '.smsm-side__p{margin:3px 0 0;font-size:13px;color:#6B6280;line-height:1.6}' +
    '.smsm-side--free .smsm-side__ic{background:#1F9D55}' +
    '.smsm-gift{display:block}' +
    '.smsm-gift__top{display:flex;align-items:center;gap:14px}' +
    '.smsm-gift__btn{all:unset;box-sizing:border-box;display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin-top:14px;min-height:46px;border-radius:12px;background:#2B1748;color:#fff;font-weight:900;font-size:14.5px;cursor:pointer}' +
    '.smsm-gift.is-on .smsm-gift__btn{background:#ECFBF1;color:#14532D;border:1px solid #9FDDB4}' +
    '.main-cart #gift{display:none!important}' +
    /* ملخص الطلب */
    '.smsm-sum{margin:0 0 6px}' +
    '.smsm-sum__h{margin:0 0 12px;font-size:16px;font-weight:900;color:#2B1748}' +
    '.smsm-sum__r{display:flex;justify-content:space-between;align-items:center;margin:0 0 9px;font-size:14px;color:#5E5470}' +
    '.smsm-sum__r b{color:#2B1748;font-weight:800}' +
    '.smsm-sum__r.is-disc b{color:#C0392B}' +
    '.smsm-sum__tot{display:flex;justify-content:space-between;align-items:center;margin:12px 0 0;padding-top:12px;border-top:1px dashed #DCCFEA;font-size:17px;font-weight:900;color:#2B1748}' +
    '.smsm-sum__tot s{margin-inline-start:6px;font-size:13px;font-weight:600;color:#9A90AA}' +
    '.smsm-sum__save{display:inline-flex;align-items:center;gap:5px;margin-top:10px;padding:5px 12px;border-radius:999px;background:#ECFBF1;color:#1F9D55;font-size:13px;font-weight:900}' +
    '.main-cart .cart-info .totals{display:none!important}';

  function addCss() { if (document.getElementById('smsm-cl-css')) return; var s = document.createElement('style'); s.id = 'smsm-cl-css'; s.textContent = css; document.head.appendChild(s); }

  function getCmp() {
    if (!cart) return Promise.resolve();
    var need = cart.items.filter(function (it) { return !(it.handle in cmp); });
    return Promise.all(need.map(function (it) {
      cmp[it.handle] = {};
      return fetch(ROOT + 'products/' + it.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (p) p.variants.forEach(function (v) { cmp[it.handle][v.id] = v.compare_at_price || 0; });
      }).catch(function () {});
    }));
  }

  function cards() {
    var rows = document.querySelectorAll('.main-cart table.cart-items tbody tr');
    rows.forEach(function (tr, i) {
      var it = cart && cart.items[i]; if (!it) return;
      var c = (cmp[it.handle] || {})[it.variant_id] || 0;
      var pr = tr.querySelector('.cart__page-price .product-option, .cart__page-price .cart-item__price-wrapper');
      if (!pr) return;
      var old = pr.querySelector('.smsm-cmp');
      if (c > it.final_price) { if (!old) { old = document.createElement('s'); old.className = 'smsm-cmp'; pr.appendChild(old); } old.textContent = fmt(c); }
      else if (old) old.remove();
    });
  }

  function side() {
    var right = document.querySelector('.main-cart .cart-right .sticky-1025') || document.querySelector('.main-cart .cart-info');
    if (!right || !cart) return;
    var box = right.classList.contains('cart-info') ? right.parentNode : right;
    /* كارت الشحن المجاني */
    var fs = box.querySelector('.smsm-side--ship');
    if (!fs) { fs = document.createElement('div'); fs.className = 'smsm-side smsm-side--ship'; fs.dir = EN ? 'ltr' : 'rtl'; box.insertBefore(fs, box.firstChild); }
    var left = FREE - cart.items_subtotal_price, free = left <= 0;
    fs.classList.toggle('smsm-side--free', free);
    var h1 = '<span class="smsm-side__ic" aria-hidden="true">🚚</span><div><p class="smsm-side__t">' + T('شحن مجاني', 'Free shipping') + '</p><p class="smsm-side__p">' +
      (free ? T('طلبك يستاهل شحن مجاني! 🎉', 'Your order ships for free! 🎉') : T('باقي <b>' + fmt(left) + '</b> وطلبك يبقى عليه شحن مجاني', '<b>' + fmt(left) + '</b> more for free shipping')) + '</p></div>';
    if (fs.innerHTML !== h1) fs.innerHTML = h1;
    /* كارت الهدية */
    var cb = document.getElementById('gift_form_minicart');
    var gf = box.querySelector('.smsm-gift');
    if (cb) {
      if (!gf) {
        gf = document.createElement('div'); gf.className = 'smsm-side smsm-gift'; gf.dir = EN ? 'ltr' : 'rtl';
        fs.parentNode.insertBefore(gf, fs.nextSibling);
        gf.addEventListener('click', function (e) { if (!e.target.closest('.smsm-gift__btn')) return; var c = document.getElementById('gift_form_minicart'); if (c) c.click(); setTimeout(side, 1200); });
      }
      var lbl = document.querySelector('#gift label'), fee = '';
      var m = lbl && lbl.textContent.replace(/,/g, '').match(/(\d+)/); if (m) fee = m[1];
      var on = cb.checked;
      gf.classList.toggle('is-on', on);
      var h2 = '<div class="smsm-gift__top"><span class="smsm-side__ic" aria-hidden="true">🎁</span><div><p class="smsm-side__t">' + T('أرسل الطلب كهدية', 'Send as a gift') + '</p><p class="smsm-side__p">' +
        T('بنغلّفه تغليف هدايا فاخر' + (fee ? ' (' + fee + ' جنيه)' : '') + '، وتقدر تكتب رسالتك في ملاحظة الطلب.', 'Luxury gift wrapping' + (fee ? ' (EGP ' + fee + ')' : '') + ' — add your message in the order note.') + '</p></div></div>' +
        '<button type="button" class="smsm-gift__btn">' + (on ? T('✓ هيتغلّف كهدية — اضغط للإلغاء', '✓ Gift wrapped — tap to remove') : T('🎁 أرسل كهدية', '🎁 Send as a gift')) + '</button>';
      if (gf.innerHTML !== h2) gf.innerHTML = h2;
    }
  }

  function summary() {
    var ci = document.querySelector('.main-cart .cart-info'); if (!ci || !cart) return;
    var sum = ci.querySelector('.smsm-sum');
    var tot = ci.querySelector('.totals');
    if (!sum) { sum = document.createElement('div'); sum.className = 'smsm-sum'; sum.dir = EN ? 'ltr' : 'rtl'; (tot ? tot.parentNode.insertBefore(sum, tot) : ci.appendChild(sum)); }
    var full = 0, cmpSave = 0;
    cart.items.forEach(function (it) {
      var c = (cmp[it.handle] || {})[it.variant_id] || 0, base = Math.max(c, it.original_price);
      full += base * it.quantity; cmpSave += Math.max(0, base - it.original_price) * it.quantity;
    });
    var save = cmpSave + (cart.total_discount || 0);
    var h = '<p class="smsm-sum__h">' + T('ملخص الطلب', 'Order summary') + '</p>' +
      '<div class="smsm-sum__r"><span>' + T('مجموع المنتجات', 'Items total') + ' (' + cart.item_count + ')</span><b>' + fmt(full) + '</b></div>' +
      (save > 0 ? '<div class="smsm-sum__r is-disc"><span>' + T('الخصم', 'Discount') + '</span><b>− ' + fmt(save) + '</b></div>' : '') +
      '<div class="smsm-sum__tot"><span>' + T('الإجمالي', 'Total') + '</span><span>' + fmt(cart.total_price) + (save > 0 ? '<s>' + fmt(full) + '</s>' : '') + '</span></div>' +
      (save > 0 ? '<span class="smsm-sum__save">🎉 ' + T('وفّرت ', 'You saved ') + fmt(save) + '</span>' : '');
    if (sum.innerHTML !== h) sum.innerHTML = h;
  }

  function openDiscount() {
    var d = document.querySelector('cart-discount.smsm-fold'); if (d && !d.dataset.smsmOpen) { d.classList.add('is-open'); d.dataset.smsmOpen = 1; }
  }

  function paint() { if (!cart) return; addCss(); cards(); side(); summary(); openDiscount(); }
  function load() {
    if (busy) return; busy = 1;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { cart = c; return getCmp(); })
      .then(function () { busy = 0; paint(); }).catch(function () { busy = 0; });
  }
  function start() {
    addCss(); load();
    var t, mc = document.querySelector('.main-cart') || document.body;
    new MutationObserver(function (ms) {
      if (ms.every(function (m) { return m.target.closest && m.target.closest('.smsm-side, .smsm-sum, .smsm-cmp'); })) return;
      clearTimeout(t); t = setTimeout(load, 250);
    }).observe(mc, { childList: true, subtree: true });
    document.addEventListener('change', function (e) { if (e.target && e.target.id === 'gift_form_minicart') setTimeout(load, 900); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
